/**
 * Переключатель месяца — один на всю программу.
 *
 * Раньше каждый раздел рисовал его по-своему: в «Финансах» и «Сотрудниках»
 * это была слитная рамка со стрелками-стрелочками «←» и «→» внутри, в
 * «Заказах» — три отдельные кнопки со значками. Отличались размеры, отступы,
 * даже сами стрелки: текстовые против нарисованных. Человек ходит по месяцам
 * во всех трёх разделах подряд, и каждый раз переключатель выглядел иначе.
 *
 * Здесь тот вид, что прижился в «Заказах»: стрелка — название — стрелка, три
 * отдельные кнопки на белом, как соседние поля и кнопки в строке.
 */

import { ChevronLeft, ChevronRight } from 'lucide-react';

export function MonthSwitcher({
  label,
  onPrev,
  onNext,
  prevDisabled = false,
  nextDisabled = false,
}: {
  /** Подпись месяца: «сентябрь 2026». */
  label: string;
  onPrev: () => void;
  onNext: () => void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
}) {
  const кнопка = 'rounded-lg border p-1 disabled:opacity-40 md:p-1.5';
  const фон = { borderColor: 'var(--otc-line)', background: 'var(--otc-surface)' };

  return (
    <span className="flex items-center gap-1.5 md:gap-2">
      <button onClick={onPrev} disabled={prevDisabled} className={кнопка} style={фон} aria-label="Предыдущий месяц">
        <ChevronLeft size={15} className="text-ink2" />
      </button>

      {/*
        `first-letter:uppercase`, а не `capitalize`: последний поднимает первую
        букву КАЖДОГО слова, и месяц печатался как «Сентябрь 2026 Г.» — с
        большой «Г» в сокращении «г.».
      */}
      <span
        className="min-w-[7rem] whitespace-nowrap rounded-lg border px-2 py-1 text-center text-xs font-medium text-ink first-letter:uppercase md:min-w-[9rem] md:px-3 md:py-1.5 md:text-sm"
        style={фон}
      >
        {label}
      </span>

      <button onClick={onNext} disabled={nextDisabled} className={кнопка} style={фон} aria-label="Следующий месяц">
        <ChevronRight size={15} className="text-ink2" />
      </button>
    </span>
  );
}
